import React from "react";

const PunchCardsAsciiLogo: React.FunctionComponent = () => {
  return <span>▛▞▗</span>;
};

export default PunchCardsAsciiLogo;
